module.exports = __webpack_public_path__ + "static/img/animation3.58a76e5.png";